import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {LoginPresenter} from "./loginPresenter";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class LoginView extends ViewBase implements IView {

    public _presenter: LoginPresenter;

    get email() {
        return this.getValueById('email');
    }

    set email(email) {
        this.setValueById('email', email);
    }

    get password() {
        return this.getValueById('password');
    }

    set password(password) {
        this.setValueById('password', password);
    }


    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer, presenter: LoginPresenter) {
        super(viewName, router, dependencyContainer);
        this._presenter = presenter;
    }

    setPresenter(presenter: LoginPresenter) {
        this._presenter = presenter;
    }

    render(): void {
    }


}